module.exports = __webpack_public_path__ + "static/media/wanderer-bracelets-5.e4b16086.jpg";